import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiceOne, faDiceTwo, faDiceThree, faDiceFour, faDiceFive, faDiceSix  } from '@fortawesome/free-solid-svg-icons';
import './Dado.css';
import { useAlteradoContext } from './AlteradoProvider';


const Dado = () => {

  const [numero, setNumero] = useState(null);
/*   const {setMostrarDado} = useAlteradoContext(); */
   const {mostrarDado, setMostrarDado} = useAlteradoContext();
    const {botaoClicado, setBotaoClicado } = useAlteradoContext();
    const {mensagemnova, setMensagemnova } = useAlteradoContext();
   
   
  
  const rolarDado = () => {
    setNumero(Math.floor((Math.random() * 6) + 1));
/*     console.log(numero);
 */    setBotaoClicado(null);
       setMensagemnova(null);
  

  };
    
  const renderizarDado = () => {
    switch (numero) {

      case 1:
        return <FontAwesomeIcon icon={faDiceOne} className="dice dice-num" id='dice-efeito'/>;
      case 2:
        return <FontAwesomeIcon icon={faDiceTwo} className="dice dice-dois" id='dice-efeito'/>;
      case 3:
        return <FontAwesomeIcon icon={faDiceThree} className="dice" id='dice-efeito' />;
      case 4:
        return <FontAwesomeIcon icon={faDiceFour} className="dice" id='dice-efeito' />;
      case 5:
        return <FontAwesomeIcon icon={faDiceFive} className="dice" id='dice-efeito' />;
      case 6:
        return <FontAwesomeIcon icon={faDiceSix} className="dice" id='dice-efeito'/>;

      default:
        return null;

     }

  };

 
  return (
    

      <div className="dado-container">


        <div className= "dado">


          <button className="dado-button" onClick={rolarDado}>
         
            {numero ? (
          
              renderizarDado()
            ) : (
       <FontAwesomeIcon icon={faDiceSix} className="dice"/>
            )}

          </button>

        </div>

      </div>


    
    
  );
};

export default Dado;
